import React from 'react';

function ActionButtonContentContainer(props) {
    return (
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
        }}>
            {props.children}
        </div>
    );
}

export default ActionButtonContentContainer;
